import { render } from "./BuscarCanciones.vue?vue&type=template&id=2b8bc837&scoped=true"
import script from "./BuscarCanciones.vue?vue&type=script&lang=js"
export * from "./BuscarCanciones.vue?vue&type=script&lang=js"

import "./BuscarCanciones.vue?vue&type=style&index=0&id=2b8bc837&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8bc837"]])

export default __exports__